import { MessageCenterPage } from "./MessageCenterPage";

export const pages = {
  "message-center": MessageCenterPage,
};
